/*
 * @Author: jiangshaodong
 * @Date: 2024-03-19 13:44:55
 * @Description: 
 * Copyright (c) 2024 by Fotor, All Rights Reserved. 
 */
import FTEventTarget, { FTEVENT_CONSTANTS } from "./FTEventTarget";

import { initAD } from "./ads";

class FTADManager {
  isReady: boolean = false;
  constructor() { }

  ready() {
    // 防止多次绑定
    // if(this.isReady) return;
    FTEventTarget.getInstance().addEvent(FTEVENT_CONSTANTS.USERINFO_CHANGED, initAD);
    FTEventTarget.getInstance().addEvent(FTEVENT_CONSTANTS.USER_VIP_CHANGED, initAD);
    this.isReady = true;
  }

  init(adInfo?: any,callback?) {
    initAD(adInfo,callback);
  }
}

export default new FTADManager();